/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Dropdown, Link } from '@carbon/react';
import styled from 'styled-components';

import { configuredClustersStore } from 'stores';

export default function DevelopmentClusterSelection({ developmentCluster, setDevelopmentCluster }) {
  return (
    configuredClustersStore.clusters?.length > 0 && (
      <_Dropdown
        titleText="Select a development cluster"
        helperText={
          <span>
            This will be the preferred cluster for deployment during development.{' '}
            <Link
              href="https://docs.camunda.io/docs/next/components/modeler/web-modeler/process-applications/#create-a-process-application"
              target="_blank"
            >
              Learn more
            </Link>
          </span>
        }
        id="cluster-selection-dropdown"
        label="Select a development cluster"
        selectedItem={developmentCluster}
        items={configuredClustersStore.clusters}
        // @ts-ignore
        itemToString={({ name, version }) => `${name} ${version ? `(${version})` : ''}`}
        onChange={({ selectedItem }) => {
          setDevelopmentCluster(selectedItem);
        }}
      />
    )
  );
}

const _Dropdown = styled(Dropdown)`
  width: 375px;
  margin-bottom: 10px;
`;
